/**
 * Panama time. There is no daylight saving in Panama, ever, so the offset is a
 * constant and no time zone library is needed. Everything is stored in UTC and
 * shown in America/Panama (Section 3).
 */

const PANAMA_OFFSET_MS = -5 * 3600 * 1000;

/** yyyy-mm-dd on the island's wall clock. */
export function panamaDateOf(at: Date | number = Date.now()): string {
  const ms = typeof at === 'number' ? at : at.getTime();
  return new Date(ms + PANAMA_OFFSET_MS).toISOString().slice(0, 10);
}

/** The Monday that starts the week a date falls in, as yyyy-mm-dd. */
export function weekStartOf(date: string): string {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  const utc = Date.UTC(y, m - 1, d);
  const day = new Date(utc).getUTCDay();
  const back = (day + 6) % 7;
  return new Date(utc - back * 86_400_000).toISOString().slice(0, 10);
}

export function currentWeekStart(at: Date | number = Date.now()): string {
  return weekStartOf(panamaDateOf(at));
}

/** Adds whole days to a yyyy-mm-dd string. */
export function addDays(date: string, days: number): string {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d) + days * 86_400_000).toISOString().slice(0, 10);
}

export function formatTime(iso: string, lang: 'es' | 'en'): string {
  return new Intl.DateTimeFormat(lang === 'es' ? 'es-PA' : 'en-US', {
    timeZone: 'America/Panama',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso));
}

/** "jue 24 sep", from a yyyy-mm-dd. Built at noon UTC so the day never slips. */
export function formatDay(date: string, lang: 'es' | 'en'): string {
  return new Intl.DateTimeFormat(lang === 'es' ? 'es-PA' : 'en-US', {
    timeZone: 'UTC',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  }).format(new Date(`${date}T12:00:00Z`));
}
